module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTEgMUgzYTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjdsLTYtNnoiLz4NCiAgICAgICAgPHBhdGggZD0iTTExIDF2Nmg2TTEzIDEySDVNMTMgMTZINU03IDhINSIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-nalog-blue.svg
// module id = yA9E
// module chunks = 1